import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { AuthProvider } from '../contexts/AuthContext';
import { ToastProvider } from '../contexts/ToastContext';
import RootErrorBoundary from '../components/feedback/ErrorBoundary';

/**
 * Composición de providers. Orden importa:
 * - ErrorBoundary más afuera para capturar errores de los providers.
 * - ToastProvider antes de AuthProvider para que errores de auth puedan disparar toasts.
 * - FamilyContext y PetsContext se montan más abajo (dentro de AppShell)
 *   porque dependen de un usuario autenticado con familyId.
 */
const App = () => {
  return (
    <RootErrorBoundary>
      <ToastProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </ToastProvider>
    </RootErrorBoundary>
  );
};

export default App;